var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "review-page" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.displayContractMessage
              ? {
                  key: "after",
                  fn: function () {
                    return [
                      _c("h3", { attrs: { id: "loading-notice" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.checkoutContent.pageLoadingText
                              .generating_contract
                          )
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.pageDataFetched
        ? _c(
            "div",
            [
              _c("checkout-header", {
                attrs: {
                  categoryFilter: { display: false },
                  shoppingBag: { display: false },
                  activePage: "review",
                },
                on: {
                  "contact-us": function ($event) {
                    _vm.showContactUsModal = true
                  },
                },
              }),
              _vm._v(" "),
              _vm.baselinePhoenixChanges && _vm.showEditBillingModal
                ? _c("EditBilling", {
                    attrs: {
                      title:
                        _vm.renewalsPersistedVariables.jsonContent.text
                          .editYourBillingInformation,
                      "button-text":
                        _vm.renewalsPersistedVariables.jsonContent.buttons
                          .submit,
                    },
                    on: {
                      "hide-modal": function ($event) {
                        _vm.showEditBillingModal = false
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.baselinePhoenixChanges && _vm.showContactUsModal
                ? _c("ContactUs", {
                    attrs: {
                      "button-text":
                        _vm.renewalsPersistedVariables.jsonContent.buttons
                          .submit,
                      locale: _vm.locale,
                    },
                    on: {
                      "hide-modal": function ($event) {
                        _vm.showContactUsModal = false
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.baselinePhoenixChanges && _vm.showAdjustQuantitiesModal
                ? _c("AdjustQuantities", {
                    attrs: {
                      productPrices: _vm.productPrices,
                      locale: _vm.locale,
                    },
                    on: {
                      "hide-modal": function ($event) {
                        _vm.showAdjustQuantitiesModal = false
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "review-body" } },
                [
                  _c(
                    "div",
                    { staticClass: "row", attrs: { id: "order-shipping" } },
                    [
                      !_vm.baselinePhoenixChanges
                        ? _c("address-confirmation", {
                            staticClass: "col xs-12 md-6",
                            attrs: {
                              address: _vm.shipping,
                              title:
                                _vm.checkoutSharedContent.opportunityInfoHeaders
                                  .ship_to,
                              editInfoText:
                                _vm.renewalsPersistedVariables.jsonContent
                                  .buttons.editInfo,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isExistingCustomer || _vm.baselinePhoenixChanges
                        ? _c("address-confirmation", {
                            staticClass: "col xs-12 md-6",
                            attrs: {
                              address: _vm.billing,
                              title:
                                _vm.checkoutSharedContent.opportunityInfoHeaders
                                  .bill_to,
                              editInfoText:
                                _vm.renewalsPersistedVariables.jsonContent
                                  .buttons.editInfo,
                            },
                            on: {
                              editBilling: function ($event) {
                                _vm.showEditBillingModal = true
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("payment-plan-container", {
                    on: {
                      scrollToPricingBreakdown: _vm.scrollToPricingBreakdown,
                      toggleTerm: _vm.toggleTerm,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "pricingBreakdown",
                      staticClass: "scroll-pricing-breakdown",
                    },
                    [
                      _c("pricing-breakdown", {
                        attrs: { pageLoaded: _vm.pageDataFetched },
                        on: {
                          adjustQuantities: function ($event) {
                            _vm.showAdjustQuantitiesModal = true
                          },
                          productPrices: _vm.setProductPrices,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedPaymentType && !_vm.hasExceededFinanceLimit
                    ? [
                        _c(
                          "keep-alive",
                          [
                            _c("payment-method", {
                              staticClass: "margin-top-20",
                              attrs: {
                                ownerEmail: _vm.ownerEmail,
                                availablePaymentMethods:
                                  _vm.availablePaymentMethods,
                              },
                              on: { "update-send-pdf": _vm.handlePDFChange },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.checkoutType === "ExpressCheckout" && !_vm.isRenewal
                          ? _c("div", [
                              _c("div", { staticClass: "row" }, [
                                _c("div", {
                                  staticClass: "col xs-12",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.checkoutContent.dayRiskFree
                                    ),
                                  },
                                }),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("agreement", {
                          ref: "termsOfAgreement",
                          attrs: {
                            agreementText: _vm.agreementText,
                            confirmationText:
                              _vm.checkoutSharedContent.agreeToTerms,
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      attrs: { id: "checkout-button-container" },
                    },
                    [
                      _c("div", { staticClass: "col xs-12 flex flex-around" }, [
                        _c(
                          "button",
                          {
                            attrs: {
                              id: "checkout-button",
                              disabled: _vm.submissionInProgress,
                            },
                            on: { click: _vm.submitReviewPageHandler },
                          },
                          [_vm._v(_vm._s(_vm.submitButtonText))]
                        ),
                      ]),
                    ]
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }